import { observer } from 'mobx-react'
import React from 'react'
import CheckBox from '../atoms/CheckBox'

export const SCheckBox = observer(props => {
  const { model, name, editableRef, ...rest } = props
  const checked = !!model?.[name]
  const toggleChecked = () => model?.setValue(name, !checked)
  return (
    <CheckBox {...rest} ref={editableRef} checked={checked} onPress={toggleChecked} />
  )
})
